export const skills = [
    // Frontend
    { name: "HTML", level: 80, category: "Frontend" },
    { name: "CSS", level: 60, category: "Frontend" },
    { name: "Bootstraps", level: 70, category: "Frontend" },
    { name: "JavaScript", level: 80, category: "Frontend" },
    { name: "jQuery", level: 60, category: "Frontend" },
    { name: "React", level: 70, category: "Frontend" },

    // Backend
    { name: "ASP .NET Core", level: 60, category: "Backend" },
    { name: ".NET", level: 60, category: "Backend" },
    { name: "Web API", level: 70, category: "Backend" },
    { name: "Web Form", level: 50, category: "Backend" },
    { name: "C#", level: 70, category: "Backend" },
    { name: "SQL Server", level: 70, category: "Backend" },
    { name: "MySQL", level: 60, category: "Backend" },
    { name: "Python", level: 60, category: "Backend" },

    // Other
    { name: "Git", level: 70, category: "Other" },
    { name: "Jira", level: 50, category: "Other" },
    { name: "Azure", level: 50, category: "Other" },
];